export default "__VITE_ASSET__i$$sCak5__"